module.exports = __webpack_public_path__ + "static/media/88 back screen.5557e4f5.webp";